<template>
  <!-- Footer start -->
  <footer class="relative w-full px-4 pt-10 pb-16 bg-[#120F14] border-t border-gray-800/60 lg:py-16">
    <div class="max-w-[1400px] mx-auto">
      
      <!-- Desktop Layout -->
      <div class="hidden md:grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-16">
        
        <!-- Left Column (Logo & Gambling Problem Info) -->
        <div class="flex flex-col space-y-4">
          <!-- Logo Section -->
          <div class="flex items-center">
            <a href="#home">
              <img
                src="@/assets/revamp/logo2.webp"
                class="w-auto h-[48px] object-contain"
                alt="logo"
              />
            </a>
          </div>

          <!-- Email Contact -->
          <div class="flex items-center gap-2.5 pt-1">
            <div class="flex items-center justify-center w-[24px] h-[16px] bg-[#e6e6ff] rounded-[3px]">
               <span class="text-[#3b82f6] text-[12px] font-black leading-none mt-[1px]">@</span>
            </div>
            <a href="mailto:maherco@maherco.gg" class="text-white text-[15px] hover:text-[#00F0FF] underline underline-offset-4 decoration-white/60 hover:decoration-[#00F0FF] font-medium transition-colors">
              maherco@maherco.gg
            </a>
          </div>
          <!-- Text -->
          <p class="text-[#B9CACB] text-sm leading-relaxed max-w-xl">
            {{ $t("Footer.Gambling_Problem") }}
          </p>
          <!-- Link -->
          <p class="text-sm text-[#B9CACB]">
            {{ $t("Footer.Find_Help") }}
            <a 
              href="https://www.ncpgambling.org/" 
              target="_blank" 
              class="text-[#00F0FF] hover:underline font-bold transition-all duration-200"
            >
              https://www.ncpgambling.org/
            </a>
            {{ $t("Footer.For_More_Info") || ' for more information.' }}
          </p>
        </div>

        <!-- Right Column (Social Icons & Responsibility Info) -->
        <div class="flex flex-col space-y-4 md:items-end">
          <!-- Social Icons Row -->
          <div class="flex flex-row items-center gap-4 py-2 w-full justify-start md:justify-end">
            <!-- Included Discord for desktop as well since it's nice to have parity -->
            <a href="https://www.youtube.com/mahercogaming1" target="_blank" class="text-[#B9CACB] hover:text-white transition-colors">
              <svg viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
            </a>
            <a href="https://www.tiktok.com/@maherco_me" target="_blank" class="text-[#B9CACB] hover:text-white transition-colors">
              <svg viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 15.68a6.34 6.34 0 0010.86 4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1.04-.54z"/></svg>
            </a>
            <a href="https://discord.com/invite/N764VWuGyn" target="_blank" class="text-[#B9CACB] hover:text-[#5865F2] transition-colors">
              <svg viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6"><path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189z"/></svg>
            </a>
            <a href="https://kick.com/maherco" target="_blank" class="text-[#B9CACB] hover:text-[#53fc18] transition-colors">
              <svg viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
                <rect x="4" y="2" width="4" height="20" />
                <rect x="8" y="10" width="4" height="4" />
                <rect x="12" y="6" width="4" height="4" />
                <rect x="16" y="2" width="4" height="4" />
                <rect x="12" y="14" width="4" height="4" />
                <rect x="16" y="18" width="4" height="4" />
              </svg>
            </a>
            <a href="https://www.facebook.com/Mahercogaming" target="_blank" class="text-[#B9CACB] hover:text-white transition-colors">
              <svg viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6"><path d="M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4v-8.5z"/></svg>
            </a>
          </div>

          <!-- Text -->
          <p class="text-[#B9CACB] text-sm leading-relaxed max-w-xl text-left">
            {{ $t("Footer.No_Responsibility") }}
          </p>
        </div>

      </div>

      <!-- Mobile Layout -->
      <div class="flex flex-col items-center md:hidden space-y-6 text-center w-full">
        <!-- Logo -->
        <a href="#home" class="mb-1">
          <img
            src="@/assets/revamp/logo2.webp"
            class="w-auto h-[52px] object-contain"
            alt="logo"
          />
        </a>

        <!-- Social Icons Row -->
        <div class="flex flex-row items-center justify-center gap-3.5">
          <a href="https://www.youtube.com/mahercogaming1" target="_blank" class="text-[#B9CACB] hover:text-white transition-colors">
            <svg viewBox="0 0 24 24" fill="currentColor" class="w-[26px] h-[26px]"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
          </a>
          <a href="https://www.tiktok.com/@maherco_me" target="_blank" class="text-[#B9CACB] hover:text-white transition-colors">
            <svg viewBox="0 0 24 24" fill="currentColor" class="w-[26px] h-[26px]"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 15.68a6.34 6.34 0 0010.86 4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1.04-.54z"/></svg>
          </a>
          <a href="https://discord.com/invite/N764VWuGyn" target="_blank" class="text-[#B9CACB] hover:text-[#5865F2] transition-colors">
            <svg viewBox="0 0 24 24" fill="currentColor" class="w-[26px] h-[26px]"><path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189z"/></svg>
          </a>
          <a href="https://kick.com/maherco" target="_blank" class="text-[#B9CACB] hover:text-[#53fc18] transition-colors">
            <svg viewBox="0 0 24 24" fill="currentColor" class="w-[26px] h-[26px]">
              <rect x="4" y="2" width="4" height="20" />
              <rect x="8" y="10" width="4" height="4" />
              <rect x="12" y="6" width="4" height="4" />
              <rect x="16" y="2" width="4" height="4" />
              <rect x="12" y="14" width="4" height="4" />
              <rect x="16" y="18" width="4" height="4" />
            </svg>
          </a>
          <a href="https://www.facebook.com/Mahercogaming" target="_blank" class="text-[#B9CACB] hover:text-white transition-colors">
            <svg viewBox="0 0 24 24" fill="currentColor" class="w-[26px] h-[26px]"><path d="M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4v-8.5z"/></svg>
          </a>
        </div>

        <!-- Email Contact -->
        <div class="flex items-center justify-center gap-2.5">
          <div class="flex items-center justify-center w-[24px] h-[16px] bg-[#e6e6ff] rounded-[3px]">
             <span class="text-[#3b82f6] text-[12px] font-black leading-none mt-[1px]">@</span>
          </div>
          <a href="mailto:maherco@maherco.gg" class="text-white text-[15px] hover:text-[#00F0FF] underline underline-offset-4 decoration-white/60 hover:decoration-[#00F0FF] font-medium transition-colors">
            maherco@maherco.gg
          </a>
        </div>

        <!-- Text -->
        <p class="text-[#B9CACB] text-sm leading-relaxed max-w-sm mt-4">
          {{ $t("Footer.Gambling_Problem") }}
        </p>

        <!-- Link -->
        <p class="text-sm text-[#B9CACB] max-w-sm">
          {{ $t("Footer.Find_Help") }}
          <a 
            href="https://www.ncpgambling.org/" 
            target="_blank" 
            class="text-[#00F0FF] hover:underline font-bold transition-all duration-200"
          >
            https://www.ncpgambling.org/
          </a>
          {{ $t("Footer.For_More_Info") || ' for more information.' }}
        </p>

        <!-- Responsibility Text -->
        <p class="text-[#B9CACB] text-sm leading-relaxed max-w-sm mt-4">
          {{ $t("Footer.No_Responsibility") }}
        </p>

      </div>

    </div>
  </footer>
  <!-- Footer end -->
</template>

<script>
export default {
  name: "FooterElement",
  props: {
    activeSection: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      // navItems: [
      //   { id: "home", name: "Home" },
      //   { id: "promotions", name: "Promotions" },
      //   { id: "socials", name: "Socials" },
      //   { id: "leaderboards", name: "Leaderboards" },
      // ],
    };
  },
};
</script>
